import React from 'react';
import { Modal } from 'react-bootstrap';
import NodeForm from './NodeForm';
import { Encodings, Node } from 'reducers/nodesReducer';
import { Script } from 'reducers/scriptReducer';

type TEnableNodePopup = {
  node: Node;
  encodings: Encodings;
  scripts: Script[];
  onClose: () => void;
  onSave: (_: Node) => void;
  pending: boolean;
  aetsAlreadyTaken: string[];
  onDicomEchoClick: (_: Node) => void;
};

export default function EditNodePopup({
  node,
  encodings,
  scripts,
  onClose,
  onSave,
  pending,
  aetsAlreadyTaken,
  onDicomEchoClick,
}: TEnableNodePopup): React.ReactElement {
  return (
    <Modal show size="lg">
      <Modal.Header>
        <Modal.Title>Editing node {node.aeTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <NodeForm
          aetsAlreadyTaken={aetsAlreadyTaken}
          node={node}
          encodings={encodings}
          onClose={onClose}
          onSave={onSave}
          pending={pending}
          saveButtonLabels={['Save changes', 'Saving..']}
          nodes={[] as string[]}
          onDicomEcho={onDicomEchoClick}
          scripts={scripts}
        />
      </Modal.Body>
    </Modal>
  );
}
